import { render, staticRenderFns } from "./ConfirmAddNewPayee.vue?vue&type=template&id=55997bfd"
import script from "./ConfirmAddNewPayee.vue?vue&type=script&lang=js"
export * from "./ConfirmAddNewPayee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports